{
  "common": {
    "submit": "Submit",
    "cancel": "Cancel",
    "info": "Weitere Informationen"
  }
}
